// ===== MODELS =====

// User Model
export class User {
  constructor(data = {}) {
    this.id = data.id;
    this.email = data.email;
    this.emailVerified = data.emailVerified || false;
    this.emailVerifiedAt = data.emailVerifiedAt || null;
    this.phone = data.phone || null;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.title = data.title;
    this.specialty = data.specialty;
    this.languagePreference = data.languagePreference || 'français';
    this.dictationLanguage = data.dictationLanguage || 'fr';
    this.isAdmin = data.isAdmin;
    this.isEnterpriseAdmin = data.isEnterpriseAdmin;
    this.createdAt = data.createdAt;
  }
}
